import request from '@/common/http/request'

// 获取分享信息
export function getShareinfo(data, isNoLoading = false) {
    const timestamp = new Date().getTime()
    return request({
        url: '/member/getShareIndexData?timestamp=' + timestamp,
        method: 'post',
        data,
        isNoLoading: isNoLoading
    })
}
// 分享获取是否隐藏邀请链接
export function getHideShareStatus(data) {
    return request({
        url: '/sys/getHideStatus',
        method: 'get',
        data,
        isNoToastErr: true
    })
}

// 分享获取合伙人信息
export function getPartnerInfo(data) {
    return request({
        url: '/memberPartner/info',
        method: 'post',
        data
    })
}

// 按日期查询下属用户信息（所有数据）
export function getUnderlingAllData(data) {
    return request({
        url: '/member/underlingAllData',
        method: 'post',
        data,
        isNoLoading: true
    })
}

// 获取分享每日数据
export function getShareDataByDate(data) {
    return request({
        url: '/member/getShareIndexPage',
        method: 'post',
        data
        // isNoLoading: true
    })
}

// 获取分享每日数据根据日期
export function getShareDataItemByDate(data) {
    return request({
        url: '/member/getShareIndexItemByDate',
        method: 'post',
        data
        // isNoLoading: true
    })
}

// 根据日期查询用户邀请信息
export function getMemberInviteTotalByDay(data) {
    return request({
        url: '/member/getMemberInviteTotalByDay',
        method: 'post',
        data
        // isNoLoading: true
    })
}
